<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="活动名称：" prop="discountName">
            <el-input style="width: 424px;" v-model="ruleForm.discountName" placeholder="请输入活动名称"></el-input>
          </el-form-item>
          <el-form-item label="活动时间：" prop="activityTime">
            <el-date-picker
              v-model="activityTime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="条件数量：" prop="number">
            <el-input style="width: 424px;" v-model="ruleForm.number" placeholder="请输入条件数量"></el-input>
            <div class="mt-warm-txt"><span>该商品活动期间内，用户购买数量达到条件数量后进行折扣</span></div>
          </el-form-item>
          <el-form-item label="折扣比例：" prop="discountRate">
            <el-input style="width: 424px;" v-model="ruleForm.discountRate" placeholder="请输入折扣比例"></el-input>
            <div class="mt-warm-txt"><span>折扣比例，8折输入0.8</span></div>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveDiscountActivity, updateDiscountActivity, fetchDiscountActivityDetailById } from '@/api/discount'
export default {
  name: 'DiscountAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      dataId: this.$route.query.dataId,
      activityTime:['',''],
      ruleForm: {
        discountName:'',
        activityTime:['',''],
        number:'',
        discountRate:'',
        status: false
      },
      rules: {
        discountName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入条件数量', trigger: 'blur' }
        ],
        discountRate: [
          { required: true, message: '请输入折扣比例', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (this.$route.query.dataId != '') {
      let that = this
      fetchDiscountActivityDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.discountName = data.discountName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.activityTime = [data.startDateTime,data.endDateTime]
          that.activityTime = [data.startDateTime,data.endDateTime]
          that.ruleForm.number = data.number
          that.ruleForm.discountRate = data.discountRate
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let discountName = that.ruleForm.discountName
      let activityTime = that.activityTime
      let number = that.ruleForm.number
      let discountRate = that.ruleForm.discountRate
      let status = that.ruleForm.status ? 1 : 0
      if (discountName === '') {
        this.$message.error('请输入活动名称')
        return false
      }
      if (activityTime[0] === '') {
        this.$message.error('请选择活动时间')
        return false
      }
      if (number === '') {
        this.$message.error('请输入条件数量')
        return false
      }
      if (discountRate === '') {
        this.$message.error('请输入折扣比例')
        return false
      }
      let passData = {
        discountName: discountName, startDateTime: activityTime[0], endDateTime: activityTime[1], number: number, discountRate: discountRate, status: status
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateDiscountActivity(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveDiscountActivity(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/discount/Add.vue